export type HoldSource = 'key' | 'pointer';

export interface HoldInput {
  readonly source: HoldSource;
  readonly id: number;
}

export const HOLD_KEYS: readonly string[] = ['Space', 'ArrowUp'];

export const UNLOCK_EVENTS: readonly string[] = ['keydown', 'mousedown', 'pointerup', 'touchend', 'click'];

const KEY_ID = -1;

export function startsOnPress(pointerType: string): boolean {
  return pointerType === 'mouse';
}

export function keyHold(): HoldInput {
  return { source: 'key', id: KEY_ID };
}

export function pointerHold(pointerId: number): HoldInput {
  return { source: 'pointer', id: pointerId };
}

export function isHoldKey(code: string): boolean {
  return HOLD_KEYS.includes(code);
}

export function acceptPress(active: HoldInput | null, input: HoldInput, repeat: boolean): boolean {
  if (repeat) return false;
  return active === null && (input.source === 'key' || input.id >= 0);
}

export function matchesRelease(active: HoldInput | null, input: HoldInput): boolean {
  return active !== null && active.source === input.source && active.id === input.id;
}
